<template>
  <div id="add-new-order-modal">
    <v-layout row justify-center>
      <v-dialog v-model="addBarcodeModal" persistent max-width="340px">
        <v-card>
          <form action="" @submit.prevent="submitForm()">
            <v-card-title>
              <v-flex xs11 sm11 md11><span class="headline">Add bitemid</span></v-flex>
              <v-flex xs1 sm1 md1>
                <v-btn flat @click="closeAddBarcodeModal(), $validator.reset()" class="close"
                  >&times;</v-btn
                >
              </v-flex>
            </v-card-title>
            <v-card-text>
              <v-alert :value="checkAlert" type="success">
                bitemid added successfully
              </v-alert>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12 sm3 md3>
                    <v-text-field
                      label="bitemid*"
                      v-model="addBarcodeData.barcode"
                      :error-messages="errors.collect('bitemid')"
                      v-validate="'required'"
                      data-vv-name="bitemid"
                    >
                    </v-text-field>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                id="sendButton"
                type="submit"
                style="height:auto; margin-right: 7%"
                outline
                color="success"
                >ADD</v-btn
              >
            </v-card-actions>
          </form>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>
<script>
export default {
  props: ['checkAlert', 'closeAddBarcodeModal', 'addBarcodeModal', 'addBarcodeData', 'addBarcode'],

  methods: {
    submitForm() {
      this.$validator.validateAll().then(res => {
        if (res) {
          this.addBarcode()
        }
      })
    }
  }
}
</script>

<style>
.overlay--active:before {
  opacity: 50 !important;
  background: rgba(0, 0, 0, 0.5) !important;
}
</style>



// WEBPACK FOOTER //
// src/components/addBarcode.vue